import ArchiveIcon from '@mui/icons-material/Archive';
import type { GridRowSelectionModel } from '@mui/x-data-grid-pro';
import { useState } from 'react';
import * as HOOKS from '@siloreal:shared:hooks';
import * as UI from '@siloreal:shared:ui';
import { SilobagExtractionModal } from '../../silobag-extraction-modal';

const MAX_SELECTION = 2;

type Props = {
  interactionId: string;
  disabled?: boolean;
};

function getSelectedIds(selectionModel: GridRowSelectionModel): string[] {
  return Array.from(selectionModel.ids).map(String);
}

export function ExtractionInteraction({ interactionId, disabled }: Props) {
  const i18n = HOOKS.useLocale();
  const explorer = UI.collection.useExplorer();
  const [extractionIds, setExtractionIds] = useState<string[] | null>(null);
  const isDisabled = Boolean(disabled) || extractionIds !== null;
  const label = i18n.t('temp.private.list.common.new_extraction');

  const handleSelectionConfirm = (selectionModel: GridRowSelectionModel): void => {
    const selectedIds = getSelectedIds(selectionModel);
    if (selectedIds.length > 0) setExtractionIds(selectedIds);
  };

  const handleClick = (): void => {
    explorer.startSelection({
      id: interactionId,
      maxSelection: MAX_SELECTION,
      onConfirm: handleSelectionConfirm,
    });
  };

  return (
    <>
      <UI.Tooltip content={label} tid={`${interactionId}-tooltip`}>
        <UI.Button
          type="button"
          variant="safe"
          uppercase={false}
          ariaLabel={label}
          icon={<ArchiveIcon fontSize="small" />}
          disabled={isDisabled}
          onClick={handleClick}
          tid={`${interactionId}-btn`}
        />
      </UI.Tooltip>

      {extractionIds ? (
        <SilobagExtractionModal open silobagIds={extractionIds} onClose={() => setExtractionIds(null)} />
      ) : null}
    </>
  );
}
